import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-door-open-line',
    title: 'Acil Kapı Açma',
    desc: 'Evinizin, işyerinizin veya aracınızın kapısı kilitli kaldıysa 15 dakikada yanınızdayız.',
    img: 'https://readdy.ai/api/search-image?query=locksmith%20opening%20a%20residential%20door%20lock%20with%20professional%20tools%2C%20close%20up%20hands%20working%20on%20door%20handle%2C%20warm%20indoor%20lighting%2C%20clean%20modern%20apartment%20door%2C%20professional%20service&width=400&height=280&seq=svc001&orientation=landscape',
  },
  {
    icon: 'ri-lock-2-line',
    title: 'Kilit Değiştirme',
    desc: 'Eski veya hasarlı kilitlerini güvenli, modern kilitlerle değiştiriyoruz.',
    img: 'https://readdy.ai/api/search-image?query=new%20modern%20door%20lock%20installation%2C%20locksmith%20replacing%20old%20lock%20with%20new%20security%20lock%2C%20close%20up%20professional%20work%2C%20clean%20background%2C%20tools%20on%20table&width=400&height=280&seq=svc002&orientation=landscape',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Çelik Kapı Açma',
    desc: 'Çelik kapı kilitlerinde uzman ekibimizle kapınızı hasarsız açıyoruz.',
    img: 'https://readdy.ai/api/search-image?query=steel%20security%20door%20with%20professional%20locksmith%20working%20on%20it%2C%20heavy%20duty%20door%20lock%2C%20urban%20apartment%20building%20hallway%2C%20professional%20locksmith%20service&width=400&height=280&seq=svc003&orientation=landscape',
  },
  {
    icon: 'ri-car-line',
    title: 'Oto Çilingir',
    desc: 'Araç anahtarınızı kaybettiniz mi? Tüm araç markalarında anahtar kopyalama ve kapı açma.',
    img: 'https://readdy.ai/api/search-image?query=automotive%20locksmith%20working%20on%20car%20door%20lock%2C%20professional%20opening%20car%20door%2C%20modern%20vehicle%2C%20urban%20street%20background%2C%20skilled%20technician&width=400&height=280&seq=svc004&orientation=landscape',
  },
  {
    icon: 'ri-safe-line',
    title: 'Kasa Açma',
    desc: 'Şifreli veya anahtarlı kasaları güvenle açıyor, kombinasyon sıfırlama yapıyoruz.',
    img: 'https://readdy.ai/api/search-image?query=professional%20locksmith%20opening%20a%20safe%20box%2C%20combination%20lock%20safe%2C%20office%20environment%2C%20skilled%20technician%20with%20tools%2C%20focused%20work&width=400&height=280&seq=svc005&orientation=landscape',
  },
  {
    icon: 'ri-key-2-line',
    title: 'Anahtar Kopyalama',
    desc: 'Her türlü anahtar kopyalama ve yedek anahtar yapımı hızlı ve uygun fiyatla.',
    img: 'https://readdy.ai/api/search-image?query=key%20cutting%20machine%20making%20duplicate%20key%2C%20locksmith%20shop%2C%20various%20keys%20on%20display%2C%20professional%20key%20copying%20service%2C%20close%20up%20detail&width=400&height=280&seq=svc006&orientation=landscape',
  },
];

export default function ServicesPreview() {
  return (
    <section className="py-16 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-orange-500 text-xs font-bold uppercase tracking-widest mb-3">
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-tools-line"></i></span>
            Hizmetlerimiz
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">
            Profesyonel Çilingir Çözümleri
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm md:text-base">
            Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir'de tüm çilingir ihtiyaçlarınız için 7/24 hizmetinizdeyiz.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc) => (
            <article
              key={svc.title}
              className="bg-white rounded-2xl overflow-hidden border border-stone-100 hover:border-orange-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="w-9 h-9 flex items-center justify-center bg-orange-50 text-orange-500 rounded-xl">
                    <i className={`${svc.icon} text-lg`}></i>
                  </span>
                  <h3 className="font-bold text-gray-900 text-base">{svc.title}</h3>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed">{svc.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/hizmetler"
            className="inline-flex items-center gap-2 border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white font-bold px-8 py-3 rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer"
          >
            Tüm Hizmetleri Gör
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>
      </div>
    </section>
  );
}
